import VuiBox from "components/VuiBox";
import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import VuiSelect from "components/VuiSelect";
import { Fragment } from "react";

export function Paginated({ itemsCounter, pageSize, currentPage, changePage, changeSize }) {
  const pages = Array.from(Array(Math.ceil(itemsCounter / pageSize)), (_, index) => index + 1);

  const rowsPerTableOptions = [
    {
      label: "10",
      value: 10,
    },
    {
      label: "20",
      value: 20,
    },
    {
      label: "50",
      value: 50,
    },
    {
      label: "100",
      value: 100,
    },
  ];

  return (
    <VuiBox
      sx={{
        padding: "0px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
      }}
    >
      {pages.length >= 1 && (
        <Fragment>
          <Stack spacing={2}>
            <Pagination
              sx={{
                button: {
                  color: "#FFFFFF",
                  fontSize: "14px",
                  "&:hover": { background: "#344767" },
                },
                div: { color: "#FFFFFF" },
                selected: { background: "red" },
              }}
              style={{ color: "white" }}
              count={pages.length}
              defaultPage={currentPage}
              siblingCount={0}
              boundaryCount={2}
              onChange={(_, page) => changePage(page)}
            />
          </Stack>
          <VuiSelect
            onChange={({ value }) => changeSize(value)}
            options={rowsPerTableOptions}
            placeholder={pageSize}
            sx={{ overflow: "hidden" }}
          />
        </Fragment>
      )}
    </VuiBox>
  );
}
